import Repository from "@/services/Repository";

const resource = "/comments";

export default {
  fetch({ classroom, schoolYear }) {
    let params = { classroom, schoolYear };
    return Repository.get(`${resource}/`, { params });
  },
  fetchOne({ student, schoolYear }) {
    let params = { student, schoolYear };
    return Repository.get(`${resource}/student`, { params });
  },
  post(newContent) {
    return Repository.post(`${resource}/`, newContent);
  },
  update(content) {
    return Repository.put(`${resource}/id/${content.recordId}`, content.data);
  },
  directorUpdate({ schoolYear, classroom, message, signUrl }) {
    return Repository.put(`${resource}/director`, {
      schoolYear,
      classroom,
      commentMessage: message,
      signUrl
    });
  },
  delete(contentId) {
    return Repository.delete(`${resource}/id/${contentId}`);
  }
};
